import type { LatLngMeters } from './types';

const EARTH_RADIUS_M = 6_371_000;

function toRad(deg: number): number {
  return (deg * Math.PI) / 180;
}

/** Offset origin by local east/north meters (flat-earth, fine for spiderfy radii). */
export function offsetLatLngMeters(
  origin: LatLngMeters,
  eastMeters: number,
  northMeters: number,
): LatLngMeters {
  const dLat = (northMeters / EARTH_RADIUS_M) * (180 / Math.PI);
  const cosLat = Math.cos((origin.lat * Math.PI) / 180);
  const dLng =
    Math.abs(cosLat) < 1e-12
      ? 0
      : (eastMeters / (EARTH_RADIUS_M * cosLat)) * (180 / Math.PI);
  return { lat: origin.lat + dLat, lng: origin.lng + dLng };
}

/** Great-circle distance in meters (haversine). */
export function haversineMeters(a: LatLngMeters, b: LatLngMeters): number {
  const dLat = toRad(b.lat - a.lat);
  const dLng = toRad(b.lng - a.lng);
  const lat1 = toRad(a.lat);
  const lat2 = toRad(b.lat);
  const h =
    Math.sin(dLat / 2) ** 2 +
    Math.cos(lat1) * Math.cos(lat2) * Math.sin(dLng / 2) ** 2;
  return 2 * EARTH_RADIUS_M * Math.asin(Math.min(1, Math.sqrt(h)));
}
